import TopBar from "./components/TopBar";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import Synopsis from "./components/Synopsis";
import Characters from "./components/Characters";
import ChapterGuide from "./components/ChapterGuide";
import Themes from "./components/Themes";
import ReadingChannels from "./components/ReadingChannels";
import Reviews from "./components/Reviews";
import ReadingTips from "./components/ReadingTips";
import Faq from "./components/Faq";
import RelatedGenres from "./components/RelatedGenres";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <TopBar />
      <NavBar />
      <main>
        <Hero />
        <Synopsis />
        <Characters />
        <ChapterGuide />
        <Themes />
        <ReadingChannels />
        <Reviews />
        <ReadingTips />
        <Faq />
        <RelatedGenres />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}